/* eslint-disable react/jsx-no-target-blank */
import "./index.less";

import {Button, Form, Icon, Input, message} from "antd";
import {auth, setUserId} from "utils/auth";
import {chiefManage, user} from "../../api";

import HB from "../../images/hb.png";
import React from "react";
import ResetPwd from './ResetPwd'
import {actionEmums} from "actions/basic";
import {connect} from "react-redux";
import {encryptVigenere} from '../../utils/helper'
import history from "../../utils/history";
import {loginUser} from "actions/login";
import {refreshUser} from "../../redux/actions/login";
import {getUKeyCert, getUKeyChallenge, getUKeyList, uKeySign, verifyUKeyPINCode} from "../../api/ukey";

const FormItem = Form.Item;

@connect(
    state => {
        return {
            emums: state.emums,
            loginUserData: state.loginUser.allData
        };
    },
    {loginUser, actionEmums, refreshUser}
)
@Form.create()
export default class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        // if (
        //   !(
        //     this.props.emums &&
        //     this.props.emums.data &&
        //     this.props.emums.data.length > 0
        //   )
        // ) {
        //   // this.props.actionEmums();
        // }
        this.state = {
            loading: false,
            showModal: false,
            loginUniqueKey: '',
            requiredUKeyPin: false,
        };
    }

    //获取用户详情
    getUserDetail = async paramId => {
        return new Promise((resolve, reject) => {
            user.getUserDetail(paramId).then(res => {
                if (res.code === 200) {
                    //获取用户信息成功后才查询枚举
                    this.props.actionEmums();
                    resolve(res.data);
                } else {
                    resolve({});
                    message.error("用户信息获取失败");
                }
            });
        });
    };
    //获取河长详情
    getChiefDetail = async paramId => {
        return new Promise((resolve, reject) => {
            chiefManage.getDetail(paramId).then(res => {
                if (res.code === 200) {
                    resolve(res.data);
                } else {
                    resolve({});
                }
            });
        });
    };
    handleSubmit = e => {
        e.preventDefault();
        let name_ = this.props.form.getFieldsValue().userName;
        let password_ = this.props.form.getFieldsValue().password;

        this.setState({
            loginUniqueKey: name_
        })
        this.props.form.validateFields(async (err, values) => {
            const pwdRaw = values.password; //密码原文
            const encryptVigenerePassword = encryptVigenere(pwdRaw)
            if (!err) {
                //用户名
                const userName = values.userName.trim();
                let data = {
                    channel: "BROWSER",
                    loginUniqueKey: values.userName.trim(),
                    password: encryptVigenerePassword,
                };


                if (this.state.requiredUKeyPin) {
                    //获取PIN
                    const pin = values.pin.trim() || "";
                    if (!pin) {
                        message.error("请输入UKey PIN码");
                        return;
                    }
                    /**
                     * 获取要使用的UKEY
                     */
                    const ukeyResp = await getUKeyList();
                    if (!ukeyResp || ukeyResp.code !== 0) {
                        message.error("获取UKey失败, 未检测到Ukey");
                        return;
                    }
                    const ukeyInfos = JSON.parse(ukeyResp.data);
                    if (ukeyInfos.length === 0) {
                        message.error("获取UKey失败, 未检测到Ukey");
                        return;
                    }
                    const keySN = ukeyInfos[0].keySN;

                    /**
                     * 获取证书(公钥)
                     */
                    const certResp = await getUKeyCert(keySN, 2, 2);
                    if (!certResp || certResp.code !== 0) {
                        message.error("获取UKey证书失败");
                        return;
                    }
                    const cert = certResp.data;

                    /**
                     * 获取随机数
                     */
                    const challengeReq = await getUKeyChallenge();
                    if (!challengeReq || challengeReq.code !== 200) {
                        message.error("获取UKey随机数失败");
                        return;
                    }
                    const challenge = challengeReq.data;

                    /**
                     * 验证PIN
                     */
                    console.log("验证PIN", keySN, 2, pin);
                    const verifyResp = await verifyUKeyPINCode(keySN, 2, pin);
                    if (!verifyResp || verifyResp.code !== 0) {
                        const verifyInfo = JSON.parse(verifyResp.data);
                        const retryCnt = verifyInfo.retryCnt || 0;
                        message.error("不正确的UKey PIN码, 剩余验证次数: " + retryCnt);
                        return;
                    }
                    /**
                     * 数字签名
                     */
                    const signContent = `${challenge}${userName}`;
                    const signRsp = await uKeySign(keySN, 2, pin, signContent)
                    if (!signRsp || signRsp.code !== 0) {
                        message.error("UKey签名失败");
                        return;
                    }
                    const signVal = signRsp.data;
                    console.log("最终签名值", signVal);

                    data = {
                        ...data,
                        serialNumber: challenge,
                        cert,
                        signature: signVal
                    };
                }

                this.enterLoading(true);
                this.props
                    .loginUser(data)
                    .then(response => {
                        let res = response.value;

                        if (res.code === 400) {
                            if (res.bizCode === 400057) {
                                this.setState({
                                    showModal: true
                                })
                            } else if ([400081, 400082, 400083].includes(res.bizCode)) {
                                this.setState({
                                    requiredUKeyPin: true
                                })
                                if (res.bizCode === 400081) {
                                    message.error("当前登录需要UKey PIN");
                                } else {
                                    message.error("UKey签名不正确");
                                }
                            }
                        } else if (res.code === 200) {
                            message.info("登录成功!");
                            auth(res.data);
                            const userId = res.data.principal.id;
                            setUserId(userId)
                            Promise.all([
                                this.getUserDetail(userId),
                                this.getChiefDetail(userId)
                            ]).then(values => {
                                const userPrincipal = Object.assign({}, values[0], values[1]);
                                this.enterLoading(false);
                                const userAllData = this.props.loginUserData;
                                userAllData.data.principal = userPrincipal;
                                localStorage.setItem(
                                    "avatarUrl",
                                    userAllData.data.principal.avatarUrl
                                );
                                userAllData.data.getDetail = true;
                                const rolesFirstKey = Object.keys(
                                    userAllData.data.principal.roles
                                )[0];
                                userAllData.data.principal.roles =
                                    userAllData.data.principal.roles[rolesFirstKey];
                                this.props.refreshUser(userAllData).then(res => {
                                    history.push("/welcome")
                                    // let activeItems = sessionStorage.getItem("activeItem");
                                    // if (activeItems) {
                                    //   let nowPath = activeItems.split(",");
                                    //   nowPath = "/" + nowPath[nowPath.length - 1];
                                    //   history.push(nowPath);
                                    // } else {
                                    //   history.push("/index");
                                    //   // history.push("/welcome");
                                    // }
                                });
                            });
                        } else {
                            this.enterLoading(false);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        message.warn("访问异常");
                    })
                    .finally(err => {
                        this.enterLoading(false);
                    });
            }
        });
    };
    enterLoading = status => {
        this.setState({loading: status});
    };

    onChangeUserName = e => {
        this.props.form.setFieldsValue({userName: e.target.value});
    };

    emitEmpty = () => {
        this.userNameInput.focus();
        this.props.form.setFieldsValue({userName: ""});
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const suffix = this.props.form.getFieldsValue().userName ? (
            <Icon type="close-circle" onClick={this.emitEmpty}/>
        ) : null;
        return (
            <div className="login-page-wrap">
                <div className="box-out">
                    <div className="systemInfo">

                        <div className="systemName"></div>
                        <div className="container">
                            <div className="leftBox"></div>
                            <div className="dividingLine"></div>
                            <div className="rightBox">
                                <div className="box clearfix">
                                    <div className="login-inner">
                                        <Form onSubmit={this.handleSubmit}>
                                            <FormItem>
                                                {getFieldDecorator("userName", {
                                                    rules: [{required: true, message: "请输入账号"}]
                                                })(
                                                    <Input
                                                        placeholder="请输入账号"
                                                        size="large"
                                                        style={{
                                                            width: "300px"
                                                        }}
                                                        prefix={<Icon type="user" className="icon-change"/>}
                                                        suffix={suffix}
                                                        onChange={this.onChangeUserName}
                                                        ref={node => (this.userNameInput = node)}
                                                    />
                                                )}
                                            </FormItem>
                                            <FormItem>
                                                {getFieldDecorator("password", {
                                                    rules: [{required: true, message: "请输入密码"}]
                                                })(
                                                    <Input.Password
                                                        size="large"
                                                        placeholder="请输入密码"
                                                        prefix={<Icon type="lock" className="icon-change"/>}
                                                    />
                                                )}
                                            </FormItem>
                                            {
                                                this.state.requiredUKeyPin && (
                                                    <FormItem>
                                                        {getFieldDecorator("pin", {
                                                            rules: [{required: true, message: "请输入Ukey PIN"}]
                                                        })(
                                                            <Input.Password
                                                                size="large"
                                                                placeholder="请输入Ukey PIN"
                                                                prefix={<Icon type="lock" className="icon-change"/>}
                                                            />
                                                        )}
                                                    </FormItem>
                                                )
                                            }

                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                                className="loginBtn"
                                                size="large"
                                                block
                                                loading={this.state.loading}
                                            >
                                                立即登录
                                            </Button>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                    }}>
                        <div style={{
                            textAlign: "center",
                            marginBottom: "8px",
                        }}>
                            <b style={{
                                fontSize: "16px",
                                color: "#000",
                                fontWeight: "bold",

                            }}>本平台为互联网非涉密平台，严禁处理传输国家秘密。</b>
                        </div>
                        <div style={{
                            textAlign: "center",
                            marginBottom: "8px",
                        }}>
                            <b style={{
                                fontSize: "14px",
                                color: "#fff",

                            }}>主办单位：乐山市水务局丨承办单位：乐山市河湖管理站丨监督投诉渠道：0833-2428200</b>
                        </div>
                        <a href='https://beian.miit.gov.cn' target="_blank">
                            <div className="copyright" style={{height: "2vh"}}>Copyright © 乐山市河湖管理站 版权所有 蜀ICP备20010963号-3</div>
                        </a>
                        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=51110002002301" target="_blank">
                            <div className="copyright" style={{height: "4vh"}}><img width={20} height={20} src={HB} style={{marginRight: "4px"}}/>川公网安备51110002002301</div>
                        </a>

                    </div>

                </div>


                <ResetPwd loginUniqueKey={this.state.loginUniqueKey} visible={this.state.showModal} onCancel={() => this.setState({
                    showModal: false
                })}></ResetPwd>

            </div>
        );
    }
}
